export function getOnewayInternalMonths() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const internalMonths = urlParams.get("oneway_internal_months");
  if (internalMonths != null) {
    return internalMonths;
  }
  return process.env.ONEWAY_INTERNAL_MONTHS;
}

export function getHDLanerestrictionInternalMonths() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const internalMonths = urlParams.get("hdlaneres_internal_months");
  if (internalMonths != null) {
    return internalMonths;
  }
  return process.env.HDLANERES_INTERNAL_MONTHS;
}

export function getSDLanerestrictionInternalMonths() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const internalMonths = urlParams.get("sdlaneres_internal_months");
  if (internalMonths != null) {
    return internalMonths;
  }
  return process.env.SDLANERES_INTERNAL_MONTHS;
}

export function getDCWInternalMonths() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const internalMonths = urlParams.get("dcw_internal_months");
  if (internalMonths != null) {
    return internalMonths;
  }
  return process.env.DCW_INTERNAL_MONTHS;
}
